import { useEffect, useContext } from "react";
import UserContext from "../../contexts/userContext";

import { MsalAuthenticationTemplate, useMsal, useAccount } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionType } from "@azure/msal-browser";
import { loginRequest, protectedResources } from "../../authConfig";

export const authenticate = (obj) => {
    const userContext = obj.userContext;
    const setAccount = obj.setAccount;
    const account = obj.account || userContext.account;
    const inProgress = obj.inProgress || 'none';
    const instance = obj.instance || userContext.msalInstance;

    const now = new Date();
    const tokenExp = new Date(0);
    tokenExp.setUTCSeconds(account?.idTokenClaims?.exp || 0);

    if (tokenExp < now && userContext.msalInstance) {
        console.log('current token expired at ', tokenExp);
        console.log('clearing msal caches');
        userContext.msalInstance.clearCache();
    }

    if (account && inProgress === "none") {
        instance.acquireTokenSilent({
            scopes: protectedResources.graphMe.scopes,
            account: account
        }).then((response) => {
            if (account.idToken !== response.idToken) {
                console.log('applying refreshed token to user context');
                account.idToken = response.idToken;
                setAccount(instance, account);
            }
        }).catch((error) => {
            // in case if silent token acquisition fails, fallback to an interactive method
            if (error instanceof InteractionRequiredAuthError) {
                if (account && inProgress === "none") {
                    instance.acquireTokenPopup({
                        scopes: protectedResources.graphMe.scopes,
                    }).then((response) => {
                        if (account.idToken !== response.idToken) {
                            console.log('applying refreshed token to user context');
                            account.idToken = response.idToken;
                            setAccount(instance, account);
                        }
                    }).catch(error => console.log(error));
                }
            }
        });
    }
}

const AuthContent = () => {
    /**
     * useMsal is hook that returns the PublicClientApplication instance, 
     * an array of all accounts currently signed in and an inProgress value 
     * that tells you what msal is currently doing. For more, visit: 
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});

    const { userContext, setAccount } = useContext(UserContext)
    
    useEffect(() => {
        authenticate({userContext, account, inProgress, instance, setAccount});
    }, [account, inProgress, instance]);
  
    return (<></>);
};

/**
 * The `MsalAuthenticationTemplate` component will render its children if a user is authenticated 
 * or attempt to sign a user in. Just provide it with the interaction type you would like to use 
 * (redirect or popup) and optionally a [request object](https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md)
 * to be passed to the login API, a component to display while authentication is in progress or a component to display if an error occurs. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const MsalAuth = () => {
    const authRequest = {
        ...loginRequest
    };

    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={authRequest}
        >
            <AuthContent />
        </MsalAuthenticationTemplate>
      )
};